export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";
export const PENDING = "PENDING";
